module.exports = __webpack_public_path__ + "a35546eef3ea0de0d4735f23b0a0873b.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Regular/OpenSans-Regular.eot?v=1.1.0
// module id = 982
// module chunks = 0